export const RELATIONS_FETCH = 'RELATIONS_FETCH'
export const RELATIONS_FETCH_SUCCESS = 'RELATIONS_FETCH_SUCCESS'
export const RELATIONS_FETCH_FAILED = 'RELATIONS_FETCH_FAILED'

export const RELATION_CREATE = 'RELATION_CREATE'
export const RELATION_UPDATE = 'RELATION_UPDATE'
export const RELATION_UPDATE_SUCCESS = 'RELATION_UPDATE_SUCCESS'
export const RELATION_UPDATE_FAILED = 'RELATION_UPDATE_FAILED'
